export default "__VITE_ASSET__DPUACe4X__";